import type { ChartContext } from "./context";

export function buildRadialBarOption(
  context: ChartContext,
): Record<string, unknown> {
  const { data, translateNode, displayUnitLabel, unitText, palette, ct, base } =
    context;
  const ds = data.datasets[0];
  if (!ds) return base;
  const values = ds.values as number[];
  const names = data.labels;
  return {
    ...base,
    tooltip: {
      trigger: "item",
      backgroundColor: ct.bgElevated,
      borderColor: ct.border,
      formatter: (p: { name: string; value: number }) =>
        `${p.name}: ${unitText(p.value)}`,
    },
    series: [
      {
        type: "gauge",
        // Gauge titles do not support a formatter. Give each datum a stable
        // source ID and translate its display name only.
        data: names.map((name, i) => ({
          id: name,
          name: translateNode(name),
          value: values[i] ?? 0,
        })),
        startAngle: 180,
        endAngle: 0,
        detail: { formatter: () => displayUnitLabel },
        axisLine: { lineStyle: { color: [[1, palette[0]]] } },
      },
    ],
  };
}
